module.exports = __webpack_public_path__ + "media/images/ic-lista-caminho-84ab11f7611d76ef4bb3b687aafc997c.svg";